import PowerUsers from "./PowerUsers";

export default PowerUsers;
